import { useTranslation } from 'react-i18next'
import { useModalStore } from '@/hooks/useModalStore'

export function EmptyState() {
  const { t } = useTranslation()
  const openSqlImport   = useModalStore(s => s.openSqlImport)
  const openNewProject = useModalStore(s => s.openNewProject)

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-6 p-8"
      style={{ background: 'var(--bg-canvas)', color: 'var(--text-dim)' }}
    >
      <div className="text-center">
        <div className="mb-2 text-4xl opacity-30">⬡</div>
        <div className="text-sm font-semibold" style={{ color: 'var(--text)' }}>
          {t('tabs.emptyTitle')}
        </div>
        <div className="mt-1 text-[11px]">
          {t('tabs.emptyDesc')}
        </div>
      </div>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={openNewProject}
          className="rounded-xl border px-5 py-3 text-[12px] font-semibold transition-colors"
          style={{
            borderColor: 'var(--accent)',
            color:       'var(--accent)',
            background:  'rgba(99,102,241,.08)',
          }}
        >
          {t('tabs.emptyNew')}
        </button>

        <button
          type="button"
          onClick={() => openSqlImport('empty-state')}
          className="rounded-xl border px-5 py-3 text-[12px] font-semibold transition-colors"
          style={{
            borderColor: 'var(--border)',
            color:       'var(--text)',
            background:  'var(--bg-card)',
          }}
        >
          {t('tabs.emptyImport')}
        </button>
      </div>
    </div>
  )
}
